export enum Tabs {
  components = 0,
  valueSets = 1,
}
